'use client';

import { useSyncExternalStore } from 'react';

const COMPACT_WIDTH_BREAKPOINT = 1024;
const COMPACT_WIDTH_QUERY = `(max-width: ${COMPACT_WIDTH_BREAKPOINT - 1}px)`;
const COARSE_POINTER_QUERY = '(pointer: coarse)';
const HOVER_NONE_QUERY = '(hover: none)';

function subscribeWidth(onChange: () => void) {
  const mq = window.matchMedia(COMPACT_WIDTH_QUERY);
  mq.addEventListener('change', onChange);
  return () => mq.removeEventListener('change', onChange);
}

function getWidthSnapshot() {
  return window.matchMedia(COMPACT_WIDTH_QUERY).matches;
}

function subscribeCoarse(onChange: () => void) {
  const mq = window.matchMedia(COARSE_POINTER_QUERY);
  mq.addEventListener('change', onChange);
  return () => mq.removeEventListener('change', onChange);
}

function getCoarseSnapshot() {
  return window.matchMedia(COARSE_POINTER_QUERY).matches;
}

function subscribeHoverNone(onChange: () => void) {
  const mq = window.matchMedia(HOVER_NONE_QUERY);
  mq.addEventListener('change', onChange);
  return () => mq.removeEventListener('change', onChange);
}

function getHoverNoneSnapshot() {
  return window.matchMedia(HOVER_NONE_QUERY).matches;
}

/**
 * Compact touch UX: phones, tablets, and coarse-pointer devices smaller than typical laptops.
 */
export function useIsCompactTouch(): boolean {
  const narrowWidth = useSyncExternalStore(subscribeWidth, getWidthSnapshot, () => false);
  const coarsePointer = useSyncExternalStore(subscribeCoarse, getCoarseSnapshot, () => false);
  const hoverNone = useSyncExternalStore(subscribeHoverNone, getHoverNoneSnapshot, () => false);

  return narrowWidth || coarsePointer || hoverNone;
}
